import { AmountButtons } from '@/components/opportunity/sidePanel/amountButtons'
import { TxAmountInput } from '@/components/opportunity/sidePanel/txAmountInput'
import { useMaxAmount } from '@/components/opportunity/sidePanel/useMaxAmount'
import { calculateTokenPriceInUsd } from '@/utils/calculateTokenPriceInUsd'
import { cn } from '@/utils/cn'
import { formatPreciseTokenValue, formatUSD } from '@vaultsfyi/common/utils'
import type { Dispatch, ReactNode, SetStateAction } from 'react'

interface AmountInputSectionProps {
  asset: {
    symbol: string
    decimals: number
    assetPriceInUsd?: string
  }
  form: any
  inputAmount: string
  availableBalance: string
  setUseAllFunds?: Dispatch<SetStateAction<boolean>>
  isNonIdle: boolean
  tokenSelector?: ReactNode
  actionDescription?: string
}

export const AmountInputSection = ({
  asset,
  form,
  inputAmount,
  availableBalance,
  setUseAllFunds,
  isNonIdle,
  tokenSelector,
  actionDescription,
}: AmountInputSectionProps) => {
  const inputUsdValue = formatUSD(calculateTokenPriceInUsd(Number(inputAmount), Number(asset.assetPriceInUsd)) || '0')

  const balanceValue = formatPreciseTokenValue({
    value: availableBalance,
    decimals: asset.decimals,
  })

  const { handleMaxClick } = useMaxAmount({
    form,
    maxAmount: availableBalance,
    decimals: asset.decimals,
    setUseAllFunds,
  })

  return (
    <>
      <TxAmountInput
        amountForm={form}
        className={cn(isNonIdle && 'hidden')}
        actionDescription={actionDescription}
        usdValue={inputUsdValue}
        balance={balanceValue}
        asset={asset}
        tokenSelector={tokenSelector}
        onBalanceClick={handleMaxClick}
        onAmountChange={() => setUseAllFunds?.(false)}
      />
      <div className={cn(isNonIdle && 'hidden')}>
        <AmountButtons form={form} maxInputAmount={availableBalance} setUseAllFunds={setUseAllFunds} />
      </div>
    </>
  )
}
